import { observer } from 'mobx-react-lite';
import { roundTimeStore } from '../../../../store';

export const Countdown = observer(({ gameTypeId, isGameClosed, isRotate }) => {
  const { timeData } = roundTimeStore;
  const time = timeData[gameTypeId];

  return (
    <div className='pascal-game-col-circle-inner'>
      <div className='game-circle-inner-ball-wrp'>
        <div className='game-circle-inner-ball-star1' />
        <div
          className={`game-circle-inner-ball-star  ${
            isGameClosed || !isRotate[gameTypeId] ? 'stop-rotate' : 'rotate-anim'
          }`}
        />
        <div className='game-circle-inner-ball-circle-wrp'>
          <div className='game-circle-inner-ball-circle-ins'>
            {(time || time === 0) && !isGameClosed && (
              <div className='game-circle-inner-blueball'>
                <p className='blueball-count'>{time}</p>
              </div>
            )}
            <div className='game-circle-inner-redball' />
          </div>
        </div>
      </div>
    </div>
  );
});
